
const mutations = {
    tourShow: (state, payload) => {
        console.log("MUTATION tour/show", payload);

        state.tourEvent.id = payload?.id;
        state.tourEvent.delay = payload?.delay;
        state.tourEvent.params = payload?.params;
    },
};

export default mutations;
